import { Injectable } from '@angular/core'
import { environment } from '../../environments/environment'
import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TaleoService {

  constructor(private http: HttpClient) {}

  activate(taleo: object ): Observable<any> {
    return this.http.post<any>(
      environment.baseUrlWs + environment.wsVerison + 'employer/taleo', taleo
    )
  }

  retrieve(): Observable<any> {
    return this.http.get<any>(
      environment.baseUrlWs + environment.wsVerison + 'employer/taleo'
    )
  }

  retrieveStatus(): Observable<any> {
    return this.http.get<any>(
      environment.baseUrlWs + environment.wsVerison + 'employer/taleo/status'
    )
  }

  sync(): Observable<any> {
    return this.http.post<any>(
      environment.baseUrlWs + environment.wsVerison + 'employer/taleo-sync', {}
    )
  }

  retrieveRequisitionStatus(jobs_id: number): Observable<any> {
    return this.http.get<any>(
      environment.baseUrlWs + environment.wsVerison + 'employer/taleo/' + jobs_id + '/requisition'
    )
  }

  // setRequisitionStatus(jobs_id: number, requisition: Object): Observable<any> {
  //   return this.http.post<any>(
  //     environment.baseUrlWs + environment.wsVerison + 'employer/taleo/' + jobs_id + '/requisition', requisition
  //   )
  // }

  saveRequisition(jobs_id: number, requisitions_id: string) {
    return this.http.post(environment.baseUrlWs + environment.wsVerison + 'employer/taleo/' + jobs_id + '/requisition', {
      requisitions_id: requisitions_id
    });
  }

}
